export default "__VITE_ASSET__D6QArVfe__"